import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { UpdatePrompt } from "@/components/pwa/UpdatePrompt";
import { WhatsNewDialog } from "@/components/pwa/WhatsNewDialog";
import Agenda from "@/pages/Agenda";
import { BRANDING } from "@/config/branding";
import Login from "@/pages/Login";
import PasswordRecovery from "@/pages/PasswordRecovery";
import AdminSupport from "@/pages/AdminSupport";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import ClientsDogs from "@/pages/ClientsDogs";
import OwnerDetail from "@/pages/OwnerDetail";
import DogDetail from "@/pages/DogDetail";
import Services from "@/pages/Services";
import Packages from "@/pages/Packages";
import Payments from "@/pages/Payments";
import SettingsPage from "@/pages/Settings";

const AuthLoader = () => (
  <div className="min-h-screen grid place-items-center bg-background">
    <div className="flex flex-col items-center gap-3 animate-pulse" data-testid="auth-loading">
      <img src={BRANDING.logo} alt="" className="h-16 w-16 rounded-2xl object-contain bg-white/90 p-1.5 shadow-sm" />
      <div className="font-head font-extrabold text-lg text-foreground">{BRANDING.productName}</div>
    </div>
  </div>
);

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
};

const Gate = ({ children }) => {
  const { ready } = useAuth();
  if (!ready) return <AuthLoader />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Gate>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/forgot-password" element={<PasswordRecovery key="forgot" />} />
            <Route path="/reset-password" element={<PasswordRecovery key="reset" reset />} />
            <Route path="/admin/support" element={<AdminSupport />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/clienti" element={<Protected><ClientsDogs /></Protected>} />
            <Route path="/clienti/:id" element={<Protected><OwnerDetail /></Protected>} />
            <Route path="/cani/:id" element={<Protected><DogDetail /></Protected>} />
            <Route path="/prestazioni" element={<Protected><Services /></Protected>} />
            <Route path="/agenda" element={<Protected><Agenda /></Protected>} />
            <Route path="/pacchetti" element={<Protected><Packages /></Protected>} />
            <Route path="/pagamenti" element={<Protected><Payments /></Protected>} />
            <Route path="/impostazioni" element={<Protected><SettingsPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Gate>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      <UpdatePrompt />
      <WhatsNewDialog />
    </AuthProvider>
  );
}

export default App;
